import { renderSlot as _renderSlot } from "vue";
import { flatUnwrap } from "./node.js";
export const renderSlot = (slots, name, props, ...rest) => {
  if (slots[name]) {
    return _renderSlot({ ...slots, [name]: () => flatUnwrap(slots[name](), props?.unwrap || props?.mdcUnwrap) }, name, props, ...rest);
  }
  return _renderSlot(slots, name, props, ...rest);
};
